    import React from 'react'
    import Parser from 'html-react-parser';
    
    export default function TermsOfUse() {

        const wordContent = `
        

        <p class=MsoNormal align=center style='mso-margin-top-alt:auto;mso-margin-bottom-alt:
        auto;text-align:center'><b><span lang=EN-US style='font-size:24.0pt;font-family:
        "Arial",sans-serif;mso-fareast-font-family:"Times New Roman";color:black;
        mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:
        TR'>Terms of Use</span></b><span lang=EN-US style='font-size:24.0pt;font-family:
        "Arial",sans-serif;mso-fareast-font-family:"Times New Roman";color:black;
        mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:
        TR'><o:p></o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><b><span
        lang=EN-US style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'>Effective Date:</span></b><span lang=EN-US
        style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'>&nbsp;April 2025<o:p></o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
        lang=EN-US style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'>Welcome to att app (&quot;we,&quot; &quot;our,&quot;
        or &quot;us&quot;). These Terms of Use (&quot;Terms&quot;) govern your use of
        our mobile application and website (collectively, the &quot;Services&quot;). By
        accessing or using our Services, you agree to comply with these Terms. If you
        do not agree to these Terms, you may not use our Services.<o:p></o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
        lang=EN-US style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'><o:p>&nbsp;</o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
        mso-outline-level:3'><b><span lang=EN-US style='font-size:13.5pt;font-family:
        "Arial",sans-serif;mso-fareast-font-family:"Times New Roman";color:black;
        mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:
        TR'>Overview<o:p></o:p></span></b></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
        lang=EN-US style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'>Our Services enable file sharing based on location and
        provide social features such as adding friends. By using the Services, you
        agree to the rules and responsibilities outlined in these Terms, ensuring a
        secure and respectful environment for all users.<o:p></o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
        lang=EN-US style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'><o:p>&nbsp;</o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
        mso-outline-level:3'><b><span lang=EN-US style='font-size:13.5pt;font-family:
        "Arial",sans-serif;mso-fareast-font-family:"Times New Roman";color:black;
        mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:
        TR'>1.&nbsp;Eligibility<o:p></o:p></span></b></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
        lang=EN-US style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'>Our Services are intended solely for users who are 16
        years of age or older. By using our Services, you confirm that you meet this
        age requirement. If you are under the age of 16, you are not permitted to
        access or use our Services.<o:p></o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
        lang=EN-US style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'><o:p>&nbsp;</o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
        mso-outline-level:3'><b><span lang=EN-US style='font-size:13.5pt;font-family:
        "Arial",sans-serif;mso-fareast-font-family:"Times New Roman";color:black;
        mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:
        TR'>2.&nbsp;Account Registration<o:p></o:p></span></b></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
        lang=EN-US style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'>To use certain features of our Services, you must
        create an account by providing accurate and complete information, including
        your username and email address. You are responsible for maintaining the
        confidentiality of your account login details and are solely responsible for
        all activities that occur under your account. If you suspect unauthorized
        access to your account, you must notify us immediately.<o:p></o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
        lang=EN-US style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'><o:p>&nbsp;</o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
        mso-outline-level:3'><b><span lang=EN-US style='font-size:13.5pt;font-family:
        "Arial",sans-serif;mso-fareast-font-family:"Times New Roman";color:black;
        mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:
        TR'>3.&nbsp;File Sharing and Content<o:p></o:p></span></b></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
        lang=EN-US style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'>Our Services allow users to share files based on
        location. By uploading or sharing any content through our Services, you warrant
        that you have all necessary rights and permissions to do so.<o:p></o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
        lang=EN-US style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'><o:p>&nbsp;</o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
        mso-outline-level:4'><b><span lang=EN-US style='font-family:"Arial",sans-serif;
        mso-fareast-font-family:"Times New Roman";color:black;mso-font-kerning:0pt;
        mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:TR'>Prohibited
        Content<o:p></o:p></span></b></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
        lang=EN-US style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'>You agree not to upload, share, or distribute any
        content that:<o:p></o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
        margin-left:36.0pt;text-indent:-18.0pt;mso-list:l5 level1 lfo4'><![if !supportLists]><span
        lang=EN-US style='font-size:10.0pt;mso-bidi-font-size:12.0pt;font-family:"Times New Roman",serif;
        mso-fareast-font-family:"Times New Roman";color:black;mso-font-kerning:0pt;
        mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:TR'><span
        style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span></span></span><![endif]><span dir=LTR></span><span lang=EN-US
        style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'>Is illegal, harmful, threatening, abusive, or
        harassing.<o:p></o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
        margin-left:36.0pt;text-indent:-18.0pt;mso-list:l5 level1 lfo4'><![if !supportLists]><span
        lang=EN-US style='font-size:10.0pt;mso-bidi-font-size:12.0pt;font-family:"Times New Roman",serif;
        mso-fareast-font-family:"Times New Roman";color:black;mso-font-kerning:0pt;
        mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:TR'><span
        style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span></span></span><![endif]><span dir=LTR></span><span lang=EN-US
        style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'>Violates the intellectual property rights of others.<o:p></o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
        margin-left:36.0pt;text-indent:-18.0pt;mso-list:l5 level1 lfo4'><![if !supportLists]><span
        lang=EN-US style='font-size:10.0pt;mso-bidi-font-size:12.0pt;font-family:"Times New Roman",serif;
        mso-fareast-font-family:"Times New Roman";color:black;mso-font-kerning:0pt;
        mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:TR'><span
        style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span></span></span><![endif]><span dir=LTR></span><span lang=EN-US
        style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'>Contains explicit or inappropriate material.<o:p></o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
        margin-left:36.0pt;text-indent:-18.0pt;mso-list:l5 level1 lfo4'><![if !supportLists]><span
        lang=EN-US style='font-size:10.0pt;mso-bidi-font-size:12.0pt;font-family:"Times New Roman",serif;
        mso-fareast-font-family:"Times New Roman";color:black;mso-font-kerning:0pt;
        mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:TR'><span
        style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span></span></span><![endif]><span dir=LTR></span><span lang=EN-US
        style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'>Promotes discrimination, hatred, or violence.<o:p></o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
        margin-left:36.0pt'><span lang=EN-US style='font-family:"Arial",sans-serif;
        mso-fareast-font-family:"Times New Roman";color:black;mso-font-kerning:0pt;
        mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:TR'><o:p>&nbsp;</o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
        lang=EN-US style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'>We reserve the right to review and, if necessary,
        remove any content that violates these Terms or is deemed inappropriate, at our
        sole discretion.<o:p></o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
        lang=EN-US style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'><o:p>&nbsp;</o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
        mso-outline-level:3'><b><span lang=EN-US style='font-size:13.5pt;font-family:
        "Arial",sans-serif;mso-fareast-font-family:"Times New Roman";color:black;
        mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:
        TR'>4.&nbsp;Data Collection and Privacy<o:p></o:p></span></b></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
        lang=EN-US style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'>We collect and process personal information such as
        your username, name, surname, and email address to provide and improve our
        Services, enable account creation, facilitate file sharing, and support friend
        connections. By using our Services, you consent to our collection and use of
        your personal data as described in our Privacy Policy.<o:p></o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
        lang=EN-US style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'><o:p>&nbsp;</o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
        mso-outline-level:3'><b><span lang=EN-US style='font-size:13.5pt;font-family:
        "Arial",sans-serif;mso-fareast-font-family:"Times New Roman";color:black;
        mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:
        TR'>5.&nbsp;User Conduct<o:p></o:p></span></b></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
        lang=EN-US style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'>When using our Services, you agree to:<o:p></o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
        margin-left:36.0pt;text-indent:-18.0pt;mso-list:l4 level1 lfo5'><![if !supportLists]><span
        lang=EN-US style='font-size:10.0pt;mso-bidi-font-size:12.0pt;font-family:"Times New Roman",serif;
        mso-fareast-font-family:"Times New Roman";color:black;mso-font-kerning:0pt;
        mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:TR'><span
        style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span></span></span><![endif]><span dir=LTR></span><span lang=EN-US
        style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'>Use the Services only for lawful purposes.<o:p></o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
        margin-left:36.0pt;text-indent:-18.0pt;mso-list:l4 level1 lfo5'><![if !supportLists]><span
        lang=EN-US style='font-size:10.0pt;mso-bidi-font-size:12.0pt;font-family:"Times New Roman",serif;
        mso-fareast-font-family:"Times New Roman";color:black;mso-font-kerning:0pt;
        mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:TR'><span
        style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span></span></span><![endif]><span dir=LTR></span><span lang=EN-US
        style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'>Respect the privacy and rights of other users.<o:p></o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
        margin-left:36.0pt;text-indent:-18.0pt;mso-list:l4 level1 lfo5'><![if !supportLists]><span
        lang=EN-US style='font-size:10.0pt;mso-bidi-font-size:12.0pt;font-family:"Times New Roman",serif;
        mso-fareast-font-family:"Times New Roman";color:black;mso-font-kerning:0pt;
        mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:TR'><span
        style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span></span></span><![endif]><span dir=LTR></span><span lang=EN-US
        style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'>Avoid engaging in any activity that could harm or
        interfere with the proper functioning of the Services.<o:p></o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
        margin-left:36.0pt'><span lang=EN-US style='font-family:"Arial",sans-serif;
        mso-fareast-font-family:"Times New Roman";color:black;mso-font-kerning:0pt;
        mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:TR'><o:p>&nbsp;</o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
        lang=EN-US style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'>You further agree not to:<o:p></o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
        margin-left:36.0pt;text-indent:-18.0pt;mso-list:l1 level1 lfo6'><![if !supportLists]><span
        lang=EN-US style='font-size:10.0pt;mso-bidi-font-size:12.0pt;font-family:"Times New Roman",serif;
        mso-fareast-font-family:"Times New Roman";color:black;mso-font-kerning:0pt;
        mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:TR'><span
        style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span></span></span><![endif]><span dir=LTR></span><span lang=EN-US
        style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'>Impersonate any person or entity.<o:p></o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
        margin-left:36.0pt;text-indent:-18.0pt;mso-list:l1 level1 lfo6'><![if !supportLists]><span
        lang=EN-US style='font-size:10.0pt;mso-bidi-font-size:12.0pt;font-family:"Times New Roman",serif;
        mso-fareast-font-family:"Times New Roman";color:black;mso-font-kerning:0pt;
        mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:TR'><span
        style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span></span></span><![endif]><span dir=LTR></span><span lang=EN-US
        style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'>Attempt to access unauthorized areas of the Services.<o:p></o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
        margin-left:36.0pt;text-indent:-18.0pt;mso-list:l1 level1 lfo6'><![if !supportLists]><span
        lang=EN-US style='font-size:10.0pt;mso-bidi-font-size:12.0pt;font-family:"Times New Roman",serif;
        mso-fareast-font-family:"Times New Roman";color:black;mso-font-kerning:0pt;
        mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:TR'><span
        style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span></span></span><![endif]><span dir=LTR></span><span lang=EN-US
        style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'>Upload files that contain malicious code, viruses, or
        harmful software<o:p></o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
        margin-left:36.0pt'><span lang=EN-US style='font-family:"Arial",sans-serif;
        mso-fareast-font-family:"Times New Roman";color:black;mso-font-kerning:0pt;
        mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:TR'><o:p>&nbsp;</o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
        mso-outline-level:3'><b><span lang=EN-US style='font-size:13.5pt;font-family:
        "Arial",sans-serif;mso-fareast-font-family:"Times New Roman";color:black;
        mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:
        TR'>6.&nbsp;Intellectual Property<o:p></o:p></span></b></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
        lang=EN-US style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'>All content, features, and functionality available
        through the Services, including but not limited to text, graphics, logos, and
        software, are owned by us or our licensors and are protected by intellectual
        property laws. You may not copy, reproduce, distribute, or create derivative
        works without our prior written consent.<o:p></o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
        lang=EN-US style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'><o:p>&nbsp;</o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
        mso-outline-level:3'><b><span lang=EN-US style='font-size:13.5pt;font-family:
        "Arial",sans-serif;mso-fareast-font-family:"Times New Roman";color:black;
        mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:
        TR'>7.&nbsp;Termination<o:p></o:p></span></b></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
        lang=EN-US style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'>We reserve the right to suspend or terminate your
        access to the Services at any time, with or without notice, for violating these
        Terms or engaging in activities that may harm the Services, other users, or
        third parties.<o:p></o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
        lang=EN-US style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'><o:p>&nbsp;</o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
        mso-outline-level:3'><b><span lang=EN-US style='font-size:13.5pt;font-family:
        "Arial",sans-serif;mso-fareast-font-family:"Times New Roman";color:black;
        mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:
        TR'>8.&nbsp;Disclaimer of Warranties<o:p></o:p></span></b></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
        lang=EN-US style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'>The Services are provided on an &quot;as is&quot; and
        &quot;as available&quot; basis. We disclaim all warranties, express or implied,
        including but not limited to warranties of merchantability, fitness for a
        particular purpose, and non-infringement. We do not guarantee the accuracy,
        reliability, or availability of the Services.<o:p></o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
        lang=EN-US style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'><o:p>&nbsp;</o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
        mso-outline-level:3'><b><span lang=EN-US style='font-size:13.5pt;font-family:
        "Arial",sans-serif;mso-fareast-font-family:"Times New Roman";color:black;
        mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:
        TR'>9.&nbsp;Limitation of Liability<o:p></o:p></span></b></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
        lang=EN-US style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'>To the fullest extent permitted by law, we shall not
        be liable for any indirect, incidental, consequential, or punitive damages
        arising from your use of the Services. Our total liability for any claims
        related to the Services shall not exceed the amount you have paid us, if any,
        for accessing the Services.<o:p></o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
        lang=EN-US style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'><o:p>&nbsp;</o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
        mso-outline-level:3'><b><span lang=EN-US style='font-size:13.5pt;font-family:
        "Arial",sans-serif;mso-fareast-font-family:"Times New Roman";color:black;
        mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:
        TR'>10.&nbsp;Changes to These Terms<o:p></o:p></span></b></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
        lang=EN-US style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'>We may update these Terms from time to time to reflect
        changes in our Services or legal requirements. We will notify you of
        significant changes by posting the updated Terms on our website or within the
        application. Your continued use of the Services after such updates constitutes
        your acceptance of the revised Terms.<o:p></o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
        lang=EN-US style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'><o:p>&nbsp;</o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
        mso-outline-level:3'><b><span lang=EN-US style='font-size:13.5pt;font-family:
        "Arial",sans-serif;mso-fareast-font-family:"Times New Roman";color:black;
        mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;mso-fareast-language:
        TR'>11.&nbsp;Contact Information<o:p></o:p></span></b></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
        lang=EN-US style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'>If you have any questions or concerns about these
        Terms, please contact us at legal\@att-app.com<o:p></o:p></span></p>
        
        <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
        lang=EN-US style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
        color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-ansi-language:EN-US;
        mso-fareast-language:TR'>By using our Services, you acknowledge that you have
        read, understood, and agreed to these Terms of Use.<o:p></o:p></span></p>
        
        <p class=MsoNormal><span lang=EN-US style='font-family:"Arial",sans-serif;
        mso-ansi-language:EN-US'><o:p>&nbsp;</o:p></span></p>
        

        `
    return (
        <div className='lg:w-1/2 p-2 text-sm my-5'>
            {Parser(wordContent)}

        </div>
    ) }